import { senderId } from "./shared";
import { localEnvironment, utilityServiceUrl } from "../../../../libs/menu-shared/src/environments/default-menu.config";

/* eslint-disable no-template-curly-in-string */
const environment = {
    production: true,

    API_GATEWAY: {
        KEY: "c7a04d31-5683-43a7-bde3-e4f97e4b4fb8",
        URL: "https://integrations-sit.multichoice.com/gateway"
    },

    ALLOW_COMPANY_SWITCHING: true,
    ALLOW_DEMOS: true,
    ALLOW_TOOLS: true,
    AUTO_SELECT_ACCOUNTS: 4,
    CHILD_ACCEPT_INVITE_URL: "{origin}/business/{language}/mydstv#/registration/child-accept-invite",
    CLEAR_ERROR_FILTER: ["E101", "E16", "E17", "E32", "E42", "E19"],
    DASHBOARD_URL: "{origin}/business/{language}/mydstv#/dashboard",
    DEFAULT_LANGUAGE: "en-za",
    DSTV_UTILITY_SERVICE: utilityServiceUrl,
    FRESHDESK_GROUP_ID: "3043000310004",
    HOME_PAGE_URL: "/business/{language}",
    IS_FIELD_TRIALS: false,
    PERMISSION_DATA_TIMEOUT: 2000,
    RENDER_HEADER_AND_FOOTER: false,
    REQUIRE_USER_NAMES: true,
    ROOT_PATH: "/business/{language}/mydstv#/",
    //SKIP_PREFLIGHT_CHECK: true,
    SOURCE_FOLDER: "./",
    UMBRACO_API_URL: "https://msan-app-fe-dstvweb-dev.azurewebsites.net/umbraco/api",
    USER_TRACKING_ENABLED: true,
    INBOX_ENABLED: true,

    CONNECT: {
        CLIENT_ID: "b80b0e5b-157d-4176-ac0c-946d20ae0e87",
        RETURN_URL: "{origin}/business/{language}/mydstv#/process/auth-code",
        PROXY_URL: `${utilityServiceUrl}/connect`,
        BASE_URL: "https://alpha-authentication.dstv.com",
        VERIFY_ENDPOINT: "https://ssl.dstv.com/api/auth/verify",
        TOKEN_REFRESH_TIME: 3
    },

    PAYMENT: {
        ENABLED: true,
        OVERPAYING_ENABLED: true,
        SHOW_CREDIT: true,
        USE_BALANCE: true,
        SUCCESS_URL: "{origin}/business/{language}/mydstv#/payment/success",
        FAILURE_URL: "{origin}/business/{language}/mydstv#/payment/failure",
        CANCELLED_URL: "{origin}/business/{language}/mydstv#/payment",
        MAH_SUCCESS_URL: "{origin}/#/payment/result/success",
        MAH_FAILURE_URL: "{origin}/#/payment/result/failure",
        MAH_RESULT_URL: "{origin}/#/payment/result",
        JID: "dswebpdb"
    },

    LOGGING: {
        TO_DATABASE: false,
        TO_CONSOLE: true,
        TO_LOCAL_STORAGE: true,
        ALL_RESPONSES: true
    },

    DISABLED_FEATURES: {
        BW: "",
        ET: "dashboard_paymentInfo",
        GH: "",
        KE: "dashboard_statements_download",
        MW: "",
        MZ: "",
        NA: "",
        NG: "dashboard_statements",
        TZ: "",
        UG: "",
        ZA: "",
        ZM: "",
        ZW: ""
    },

    SENDER_IDS: [
        senderId("bw", "DStv", "CEF_Test01"),
        senderId("et", "DStv", "CEF_Test01"),
        senderId("gh", "DStv", "CEF_Test01"),
        senderId("ke", "DStv_Kenya", "CEF_Test01"),
        senderId("mw", "DStv", "CEF_Test01"),
        senderId("mz", "DStv", "CEF_Test01"),
        senderId("na", "DStv", "CEF_Test01"),
        senderId("ng", "DStv", "CEF_Test01"),
        senderId("tz", "DStv", "CEF_Test01"),
        senderId("ug", "DStv", "CEF_Test01"),
        senderId("za", "27872407088", "CEF_Test01"),
        senderId("zm", "DStv", "CEF_Test01"),
        senderId("zw", "DStv", "CEF_Test01")
    ],

    menu: localEnvironment,

    analytics: {
        enabled: true,
        defaults: {
            component_name: "",
            journey_name: ""
        }
    }
};

export default environment;
